export const changeScaleScal = (scale) => {
    return {type: "changeScaleScal", payload: scale}
}
